const data = {
  title: "Floor 1-3",
  musicTrack: "MUSIC_WORLD1",
  theme: "BLUE",
  tilesWidth: 12,
  tilesHeight: 3,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 11,
      y: 2,
    },
    {
      type: "WALL",
      x: 4,
      y: 1,
    },
    {
      type: "WALL",
      x: 4,
      y: 2,
    },
    {
      type: "WALL",
      x: 6,
      y: 2,
    },
    {
      type: "WALL",
      x: 7,
      y: 2,
    },
    {
      type: "WALL",
      x: 8,
      y: 2,
    },
    {
      type: "WALL",
      x: 9,
      y: 2,
    },
    {
      type: "WALL",
      x: 9,
      y: 3,
    },
    {
      type: "KEY",
      x: 8,
      y: 3,
      color: "BLUE",
    },
    {
      type: "CHIP",
      x: 9,
      y: 1,
    },
    {
      type: "LOCK",
      x: 5,
      y: 2,
      color: "BLUE",
    },
  ],
};

export default data;
